/**
 * Masking helpers for HR PII displayed in lists (Kenya-style IDs, phones, emails).
 */

export function maskEmpNo(raw) {
  const s = raw != null ? String(raw).trim() : "";
  if (!s) return "";
  if (s.length <= 3) return "*".repeat(s.length);
  const midLen = Math.max(s.length - 4, 2);
  return s.slice(0, 2) + "*".repeat(Math.min(8, midLen)) + s.slice(-2);
}

export function maskNationalId(raw) {
  const s = raw != null ? String(raw).replace(/\s/g, "") : "";
  if (!s) return "";
  if (s.length <= 4) return "*".repeat(s.length);
  const midLen = Math.max(s.length - 4, 4);
  return s.slice(0, 2) + "*".repeat(midLen) + s.slice(-2);
}

export function maskEmail(raw) {
  if (raw == null || String(raw).trim() === "") return "";
  const email = String(raw).trim();
  const at = email.indexOf("@");
  if (at < 1) return "***";
  const local = email.slice(0, at);
  const domain = email.slice(at + 1);
  const keep = local.length <= 2 ? 1 : 2;
  return `${local.slice(0, keep)}***@${domain}`;
}

export function maskPhone(raw) {
  if (raw == null || String(raw).trim() === "") return "";
  const digits = String(raw).replace(/\D/g, "");
  if (digits.length <= 4) return "*".repeat(Math.max(digits.length, 4));
  const last4 = digits.slice(-4);
  const stars = "*".repeat(Math.min(10, digits.length - 4));
  return `${stars}${last4}`;
}

/**
 * @param {string} isoDate – date field from API
 * @param {{ (s: string): boolean }} valid – optional moment().isValid check
 */
export function maskDateOfBirth(isoDate, moment) {
  if (!isoDate || !moment) return "";
  const m = moment(isoDate);
  if (!m.isValid()) return "****";
  const y = m.format("YYYY");
  return `** • ** • ${y}`;
}
